import { render, staticRenderFns } from "./ToolTipQuestion.vue?vue&type=template&id=35f57c1c&scoped=true"
import script from "./ToolTipQuestion.vue?vue&type=script&lang=js"
export * from "./ToolTipQuestion.vue?vue&type=script&lang=js"
import style0 from "./ToolTipQuestion.vue?vue&type=style&index=0&id=35f57c1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f57c1c",
  null
  
)

export default component.exports